import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-column-config-dialog',
  templateUrl: './ColumnConfigDialog.component.html',
  styleUrls: ['./ColumnConfigDialog.component.scss']
})
export class ColumnConfigDialogComponent {

  public elements: any = [];

  public sender: number = 1;

  title_of_order = this.data.title;

  constructor(
    public dialogRef: MatDialogRef<ColumnConfigDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.elements = this.data.columns;

    this.sender = this.data.sender;

  }

  moveColumnUp(index: number) {
    if (index > 0) {
      const temp = this.elements[index];

      const next_col = this.elements[index - 1];

      if (next_col.sortable) {
        this.elements[index] = this.elements[index - 1];

        this.elements[index - 1] = temp;
      }
    }
  }

  moveColumnDown(index: number) {

    if (index < this.elements.length - 1) {

      const temp = this.elements[index];

      const next_col = this.elements[index + 1];

      if (next_col.sortable) {
        this.elements[index] = this.elements[index + 1];

        this.elements[index + 1] = temp;
      }
    }
  }

  Toggle(name: string, isHiden: boolean) {

    for (const data of this.elements) {

      if (data.name == name) {

        data.isHiden = isHiden;

        break;

      }
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSaveClick(): void {

    if (this.title_of_order) {

      const columnConfig = this.elements.map(col => ({ name: col.name, isHiden: col.isHiden, sortable: col.sortable, hideable: col.hideable }));

      localStorage.setItem(this.title_of_order, JSON.stringify(columnConfig));

      this.dialogRef.close(this.elements);
    }
  }


  getTitle(name: string): string {

    let result = name;

    if (this.sender == 1) {

      switch (name) {
        case 'row':
          result = "ردیف";
          break;

        case 'user':
          result = "نام و نام خانوادگی";
          break;

        case 'invoice':
          result = "فاکتور";
          break;

        case 'cellphone':
          result = "شماره همراه";
          break;
        case 'id2':
          result = "ش پذیرش";
          break;
        case 'id':
          result = "ش پذیرش قدیم";
          break;
        case 'shelf':
          result = "قفسه";
          break;
        case 'device':
          result = "دستگاه";
          break;
        case 'brand':
          result = "برند";
          break;
        case 'model':
          result = "مدل";
          break;
        case 'searial':
          result = "سریال";
          break;
        case 'date':
          result = "تاریخ ورود";
          break;
        case 'time':
          result = "ساعت ورود";
          break;
        case 'date2':
          result = "تاریخ خروج";
          break;
        case 'time2':
          result = "ساعت خروج";
          break;
        case 'estimated_time':
          result = "موعد تقریبی تحویل";
          break;
        case 'status':
          result = "وضعیت پذیرش";
          break;
        case 'device_status':
          result = "وضعیت دستگاه";
          break;
        case 'operation':
          result = "عملیات";
          break;
        default:
          result = name;
          break;
      }
    }
    else
      if (this.sender == 2) {
        switch (name) {
          case 'row':

            result = "ردیف";

            break;

          case 'date':

            result = "تاریخ فروش";

            break;

          case 'material':
            result = "عنوان کالا";
            break;

          case 'customer':
            result = "نام طرف حساب";
            break;
          case 'user':
            result = "فروشنده";
            break;

          case 'place':
            result = "ورودی";
            break;

          case 'reception':
            result = "ش پذیرش/فاکتور";
            break;

          case 'number':
            result = "تعداد";
            break;

          case 'factor_price':
            result = "قیمت کل خرید";
            break;

          case 'factor_price2':
            result = "قیمت کل فروش";
            break;

          case 'profit':
            result = "سود کل فروش";
            break;

          case 'porsant1':
            result = "درصد فروش";
            break;

          case 'porsant2':
            result = "پورسانت فروش";
            break;

          case 'porsant3':
            result = "سود ناخالص فروش";
            break;

          case 'discount':
            result = "تخفیف";
            break;

          case 'type':
            result = "ورودی";
            break;

          default:
            result = name;
            break;
        }
      }

      else
        if (this.sender == 3) {
          switch (name) {
            case 'row':

              result = "ردیف";

              break;

            case 'date':

              result = "تاریخ خدمات";

              break;
            case 'type':
              result = "ورودی";
              break;

            case 'reception':
              result = "ش پذیرش/فاکتور";
              break;

            case 'customer':
              result = "نام طرف حساب";
              break;

            case 'user':
              result = "نام تعمیرکار";
              break;
            case 'service':
              result = "عنوان خدمات";
              break;
            case 'factor_price':
              result = "مبلغ خدمات";
              break;
            case 'porsant1':
              result = "درصد پورسانت";
              break;

            case 'porsant2':
              result = "پورسانت خدمات";
              break;

            case 'porsant3':
              result = "سود ناخالص خدمات";
              break;

            case 'discount':
              result = "تخفیف";
              break;

            default:
              result = name;
              break;
          }
        }
    return result;

  }
}
